module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-35.5c26dc33.png";